/* tslint:disable */
/* eslint-disable */

/**
 * 1 = Red
 * 
 * 2 = Blue
 * 
 * 3 = Yellow
 * 
 * 4 = Green
 * 
 * 5 = White
 * 
 * 6 = Silver
 * 
 * 7 = Gold
 *
 * 8 = RedBlue
 *
 * 9 = Black
 */
export enum CalibrationBlockColour {
  Red = 1,
  Blue = 2,
  Yellow = 3,
  Green = 4,
  White = 5,
  Silver = 6,
  Gold = 7,
  RedBlue = 8,
  Black = 9
}
